import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';

import './map-legend.scss';

export class MapLegendOption extends Component {
  static propTypes = {
    option: PropTypes.shape({}),
    isSelected: PropTypes.bool,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    option: {},
    isSelected: false,
    onClick: null,
  };

  handleClick = () => {
    const { option, onClick } = this.props;
    onClick(option);
  };

  render() {
    const { option, isSelected, onClick } = this.props;
    const { name, color } = option;

    return (
      <li className="map-legend-option mb-1_5 mb-lg-1">
        {onClick ? (
          <Button color="link" onClick={this.handleClick} className="p-0 d-flex align-items-center">
            <span className="color-block d-block rounded" style={{ backgroundColor: color }} />
            <span
              className={classnames('label d-block ms-0_75', isSelected ? 'text-gray-darker' : 'text-primary-darker')}
            >
              {name}
            </span>
          </Button>
        ) : (
          <div className="p-0 d-flex align-items-center">
            <span className="color-block d-block rounded" style={{ backgroundColor: color }} />
            <span className="label d-block ms-0_75 text-gray-darker">{name}</span>
          </div>
        )}
      </li>
    );
  }
}

export function MapLegend({
  title = '',
  titleClassName = 'heading-3',
  onOptionClick = null,
  selectedOption = null,
  options = [],
}) {
  return (
    <section className="map-legend p-lg-1 me-lg-1 rounded mt-1_5 mt-lg-0">
      {title && <h2 className={classnames('map-legend-title mb-1_5', titleClassName)}>{title}</h2>}
      <ul className="options-list list-unstyled mb-0">
        {options.map(option => (
          <MapLegendOption
            option={option}
            onClick={onOptionClick}
            isSelected={option.name === selectedOption}
            key={option.name}
          />
        ))}
      </ul>
    </section>
  );
}

MapLegend.propTypes = {
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  onOptionClick: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  selectedOption: PropTypes.string,
};
